import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '@df/ui/translation/translation.service';

/**
 * Translates provided copy
 *
 * ## usage
 *
 * {{ 'some text' | translate }}
 * {{ 'some text % with % params' | translate : someVal : otherVal }}
 */
@Pipe({
    name: 'translate',
    standalone: true
})
export class TranslatePipe implements PipeTransform {
    /**
     * Construcor
     * @param translationService
     */
    constructor(private translationService: TranslationService) {}

    /**
     * Translation
     */
    transform(text: string | undefined | null, ...params: any[]): string {
        if (!text) {
            return '';
        }
        return this.translationService.transform(text, ...params);
    }
}
